<template>
<div>
    <v-rating v-if="vipValue" :length="6" v-model="vipValue" readonly>
        <template v-slot:item="props">
            <v-icon v-if="props.isFilled">$vuetify.icons.gem</v-icon>
            <v-icon v-if="!props.isFilled">$vuetify.icons.emptyGem</v-icon>
        </template>
    </v-rating>
</div>
</template>
<script>
export default {
    name: 'vip-level-icon',
    props: ["vipValue"]
};
</script>
<style>
</style>